import angular from 'angular';

import { TimesheetLayoutComponent } from './components/timesheet-layout.component';
import { UpdateCommentModalController } from './components/update-comment-modal.controller';
import { WeeklyTimesheetComponent } from './components/weekly-timesheet.component';

import { draggableTimerecordDirective } from './directives/draggable-timerecord.directive';
import { durationBoxDirective } from './directives/duration-box.directive';
import { timerecordDirective } from './directives/timerecord.directive';
import { trashDirective } from './directives/trash.directive';
import { weekBoxDirective } from './directives/week-box.directive';

import { DayFilter } from './filters/day.filter';
import { DurationFilter } from './filters/duration.filter';

import { TimerecordService } from './services/timerecord.service';
import { TimesheetService } from './services/timesheet.service';

const timesheet = angular.module('timesheet', [
  'ngResource',
  'ui.bootstrap',
  'toastr',
  'auth',
  'commons',
  'activities',
  'members',
]);

timesheet.component('timesheetLayout', TimesheetLayoutComponent);
timesheet.component('weeklyTimesheet', WeeklyTimesheetComponent);
timesheet.controller('UpdateCommentModalController', UpdateCommentModalController);

timesheet.directive('timerecord', timerecordDirective);
timesheet.directive('draggableTimerecord', draggableTimerecordDirective);
timesheet.directive('durationBox', durationBoxDirective);
timesheet.directive('trash', trashDirective);
timesheet.directive('weekBox', weekBoxDirective);

timesheet.filter('day', DayFilter);
timesheet.filter('duration', DurationFilter);

timesheet.service('Timerecord', TimerecordService);
timesheet.service('Timesheet', TimesheetService);

export const TimesheetModule = timesheet;